module.exports = __webpack_public_path__ + "img/t14.1694234f.png";